<app-loadable-content [loadingController]="locationLoadingController" (onRetry)="loadLocation()">
    <app-location-header [location]="location"></app-location-header>
    <div align="center">
        <app-toolbar [subject]="location" [actions]="locationToolbarModel.actions" [compactActions]="locationToolbarModel.compactActions"></app-toolbar>
    </div>
</app-loadable-content>
